module.exports = __webpack_public_path__ + "img/Neveneh_Swat_team.563b8321.jpg";